/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Text, Tooltip, VFlow } from 'bold-ui'
import { gray } from 'bold-ui/lib/styles/colors'

import { RastreamentosModel, tipoRastreamentoIconRecord } from '../model-rastreamentos'
import { RastreamentosEstratificacaoTag } from './RastreamentosEstratificacaoTag'

interface RastreamentosListCardProps {
  rastreamentos: RastreamentosModel[]
}

export function RastreamentosListCard(props: Readonly<RastreamentosListCardProps>) {
  const { rastreamentos } = props

  return (
    <VFlow vSpacing={0.5}>
      {rastreamentos.map((rastreamento) => {
        const { id, titulo, estratificacao, identificadoPor, tooltipText } = rastreamento
        const iconName = tipoRastreamentoIconRecord[titulo]

        return (
          <HFlow hSpacing={0.5} key={id}>
            <Icon icon={iconName} color={gray.c40} />
            <VFlow vSpacing={0.25}>
              <HFlow hSpacing={0.5} alignItems='center'>
                <Text fontWeight='bold'>{titulo}</Text>
              </HFlow>

              <RastreamentosEstratificacaoTag estratificacao={estratificacao} />

              <HFlow hSpacing={0.5} alignItems='center'>
                {identificadoPor && (
                  <Text fontStyle='italic' style={styles.identificadoPorText}>
                    {identificadoPor}
                  </Text>
                )}
                {tooltipText && (
                  <Tooltip text={tooltipText}>
                    <Icon icon='infoCircleFilled' size={1} />
                  </Tooltip>
                )}
              </HFlow>
            </VFlow>
          </HFlow>
        )
      })}
    </VFlow>
  )
}

const styles = {
  identificadoPorText: css`
    color: ${gray.c40};
  `,
}
